import React from "react";
//import PropTypes from "prop-types";
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { getTranslate } from "react-localize-redux";
import { getAdminTransfers, postAdminTransfer } from '../../actions/payment'

// material-ui components
import withStyles from "material-ui/styles/withStyles";

import NumberFormat from 'react-number-format';
import moment from 'moment';

// core components
import IconCard from "components/Cards/IconCard.jsx";
import RequirementsCard from "components/Cards/RequirementsCard.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import ItemGrid from "components/Grid/ItemGrid.jsx";
import Table from "components/Table/Table.jsx";
import Button from "components/CustomButtons/Button.jsx";

// material-ui icons
import Assignment from "@material-ui/icons/Assignment";
import Person from "@material-ui/icons/Person";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";

import locationsPageStyle from "assets/jss/material-dashboard-pro-react/views/locationsPageStyle.jsx";


class Transfers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  handleTableAction(action, id){
    if(action==="delete"){
    }  
    if(action==="edit"){
    }
  }

  componentDidMount() {
    this.props.dispatchGetAdminTransfers(this.props.auth.user);
  }
  render() {
    const {  translate, classes, transfers } = this.props;

    var tableData = [];
    if(transfers.length>0){
      transfers.map((prop,key)=>{
        
        let fillButtons = [
          { color: "info", icon: Person, action:"view" },
        ].map((button, buttonKey) => {
          return (
            <Button color={button.color} customClass={classes.actionButton} onClick={() => this.handleTableAction(button.action, prop.id)} key={buttonKey}>
              <button.icon className={classes.icon} />
            </Button>
          );
        });
        let amount = (<NumberFormat value={prop.amount/100} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />);        
        let date = moment(prop.arrival_date*1000).format('MMM Do YYYY, h:mm a');
        tableData.push([prop.id, amount, date, prop.destination, fillButtons]);
        return false;
      });
    }

    return (
      <div>
        <GridContainer>
          {this.state.alert}        
          <ItemGrid xs={12} sm={12} md={6}>
            <RequirementsCard content={translate("requirements.admin_transfers.content")} /> 
          </ItemGrid>                
          <ItemGrid xs={12} sm={12} md={12}>
            <IconCard
              icon={Assignment}
              iconColor="rose"
              title="Transfers"
              content={
                <Table
                  tableHead={[
                    "Id",
                    "Amount",
                    "Date",
                    "Destination",
                    "Actions"
                  ]}
                  tableData={tableData}
                />
              }
            />
          </ItemGrid>                    
        </GridContainer>
      </div>
    );
  }
}


const mapDispatchToProps = {
  dispatchGetAdminTransfers: (user) => getAdminTransfers(user),
  dispatchPostAdminTransfer: (user, data) => postAdminTransfer(user, data),
}

const mapStateToProps = (state, props) => {
  return {
    translate: getTranslate(state.localize),
    auth: state.auth,
    transfers: state.user.transfers,
  }
}


export default compose(
  withStyles(locationsPageStyle),
  connect(mapStateToProps, mapDispatchToProps)
)(Transfers);



// WEBPACK FOOTER //
// ./src/views/Admin/Transfers.jsx